module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.70f6b18.woff2";